import { CardModel, PileCardModel } from "../../interface/game";
import { SequencePolicy } from "../pile-sequence/sequence-policy";
import { PileDropPolicy } from "./pile-drop-policy";

export class PileContiguousPolicy implements PileDropPolicy {
    constructor(private sequencePolicy: SequencePolicy) {}

    canDrop(pile: PileCardModel[], dropCards: PileCardModel[], cards: {[key: string]: CardModel}): boolean {
        console.log('PileContiguousPolicy', pile, cards[pile[pile.length-1].id], cards[dropCards[0].id])
        return pile.length>0 &&
            this.sequencePolicy(cards[pile[pile.length-1].id], cards[dropCards[0].id]);
    }
}